import TextWithColorMark from "Components/textWithColorMark";
import classNames from "classnames";
import React from "react";
import zxcvbn from "zxcvbn";
import locale from "./withStrengthTooltip.locale";
export default function withStrengthTooltip(WrappedComponent) {
    function Hoc(props) {
        const { score } = zxcvbn(props.value);
        return (React.createElement(React.Fragment, null,
            React.createElement(TextWithColorMark, { title: locale.ANSWER[score], className: classNames("pb-0_5", !props.value && "invisible"), color: (score < 2 && "brand-danger-500") ||
                    (score >= 3 ? "brand-success-600" : "brand-warning-500"), markSize: 8, titleMarginLeftClassName: "ml-0_75" }),
            React.createElement(WrappedComponent, { ...props })));
    }
    Hoc.defaultProps = {
        value: ""
    };
    return Hoc;
}
